import { User } from '@/api/Auth/auth.interface'
import { BasicTransaction } from '@/utils/interfaces/topup.interface'
import { ClientRelation } from '~/utils/interfaces/remittance.interface'

export interface Agency {
  uuid: string
  name: string
  description: string
  email: string
  phone: string
  address: {
    address_1: string
    address_2: string
    city: string
    city_name: string
    locality: string
  }
  child_amount: number
  can_create: string
  image: string
  is_active: boolean
  created_at: string
  updated_at: string
  parent: string
  users: User[]
  services: string[]
  can_has_agents: boolean
  can_has_subagents: boolean
  cid: string
}

export interface Client {
  uuid?: string
  type: string
  identity: string
  first_name: string
  last_name: string
  email: string
  phone: string
  landline: string
  address: {
    address_1: string
    address_2: string
    city: null | number
    city_name: string
    country: null | number
    country_name: string
    locality: string
    region: null | number
    region_name: string
    subregion: null | number
    subregion_name: string
    zip_code: string
  }
  full_address: string
  phone_notify: boolean
  email_notify: boolean
  image: string
  created_at: string
  updated_at: string
  credit_card: string
  reference: null | string
  account_number: string
  relationship: ClientRelation
}

export type UserPaymentStatus = 'PENDING' | 'CONFIRMED' | 'CANCELED'

export interface UserPaymentItem {
  agent: string
  agent_name: string
  amount: string
  created_at: string
  status: UserPaymentStatus
  user_role: string
  uuid: string
}

export type TransactionType =
  | 'ADD_CREDIT'
  | 'REMOVE_CREDIT'
  | 'CONSUME_CREDIT'
  | 'REFUND_CREDIT'
  | 'ADD_PROVIDER_CREDIT'
  | 'REMOVE_PROVIDER_CREDIT'
  | 'CONSUME_PROVIDER_CREDIT'
  | 'REFUND_PROVIDER_CREDIT'
  | 'BALANCE_CHARGE'
  | 'BALANCE_PAYMENT'
  | 'ADD_FUND'
  | 'REMOVE_FUND'
  | 'TOPUP_CREATE'
  | 'TOPUP_REFUND'
  | 'REMITTANCE_CREATE'
  | 'REMITTANCE_REFUND'

export enum TransactionEnum {
  ADD_CREDIT = 'ADD_CREDIT',
  REMOVE_CREDIT = 'REMOVE_CREDIT',
  CONSUME_CREDIT = 'CONSUME_CREDIT',
  REFUND_CREDIT = 'REFUND_CREDIT',
  ADD_PROVIDER_CREDIT = 'ADD_PROVIDER_CREDIT',
  REMOVE_PROVIDER_CREDIT = 'REMOVE_PROVIDER_CREDIT',
  CONSUME_PROVIDER_CREDIT = 'CONSUME_PROVIDER_CREDIT',
  REFUND_PROVIDER_CREDIT = 'REFUND_PROVIDER_CREDIT',
  BALANCE_CHARGE = 'BALANCE_CHARGE',
  BALANCE_PAYMENT = 'BALANCE_PAYMENT',
  ADD_FUND = 'ADD_FUND',
  REMOVE_FUND = 'REMOVE_FUND',
  TOPUP_CREATE = 'TOPUP_CREATE',
  TOPUP_REFUND = 'TOPUP_REFUND',
  REMITTANCE_CREATE = 'REMITTANCE_CREATE',
  REMITTANCE_REFUND = 'REMITTANCE_REFUND',
}

export interface AgencyBalanceInterface extends BasicTransaction {
  type: AgencyBalanceTransactionsType
}

export interface BalanceInterface extends BasicTransaction {
  type: AgencyBalanceTransactionsType
}

export interface AgencyFundInterface extends BasicTransaction {
  type: AgencyFundTransactionsType
}

export enum AgencyBalanceTransactionsType {
  BALANCE_CHARGE = 'BALANCE_CHARGE',
  BALANCE_PAYMENT = 'BALANCE_PAYMENT',
}

export enum BalanceTransactionsType {
  BALANCE_CHARGE = 'BALANCE_CHARGE',
  BALANCE_PAYMENT = 'BALANCE_PAYMENT',
}

export enum AgencyFundTransactionsType {
  ADD_FUND = 'ADD_FUND',
  REMOVE_FUND = 'REMOVE_FUND',
}

export interface CreateAnnouncementDTO {
  title: string
  body: string
  start_date: string
  end_date: string
  agency: string
}

export interface Announcement {
  uuid: string
  title: string
  body: string
  start_date: string
  end_date: string
  agency: string
  agency_name: string
  is_active: boolean
  created_at: string
  updated_at: string
}

export interface Invoice {
  uuid: string
  agency: string
  agency_name: string
  name: string
  cid: string
  email: string
  phone: string
  address: {
    address_1: string
    address_2: string
    locality: string
    city: number
    city_name: string
    subregion_name: string
    region_name: string
    country_name: string
    subregion: number
    region: number
    country: number
    zip_code: string
  }
  full_address: string
  description: string
  amount: string
  type: 'AGENCY' | 'CLIENT'
  unit_value: number
  commission_factor: number
  profit: number
  operation_date: string
  created_at: string
  updated_at: string
}

export interface CreateInvoiceDTO {
  agency: string
  name: string
  cid: string
  email: string
  phone: string
  address: {
    address_1?: string | null
    address_2?: string | null
    locality?: string | null
    city?: number | null
    subregion?: number | null
    region?: number | null
    country?: number | null
    zip_code?: string | null
  }
  description: string
  amount: string
  type: 'AGENCY' | 'CLIENT'
  unit_value: number
  commission_factor: number
  profit: number
  operation_date: string
}
